import { Button, Column, Modal, Typography } from "matsuri-ui"
import React from "react"
import { useAccountInfoCtx } from "@/hooks/useAccountInfo"
import { useAuth } from "@/hooks/useAuth"
import { useCurrentUser } from "@/hooks/useCurrentUser"

export const AuthorityErrorDialog = () => {
    const { jwtPayload: accountInfo } = useAccountInfoCtx()
    const { logout: requestLogout } = useAuth()

    const isError = React.useMemo<boolean>(() => {
        return !(
            accountInfo?.authority === "Manager" ||
            accountInfo?.authority === "Admin"
        )
    }, [accountInfo?.authority])

    const currentUser = useCurrentUser(isError)

    return (
        <Modal
            open={isError}
            backdrop
            body={
                <Column gap={1}>
                    <Typography>管理画面の操作権限がありません。</Typography>
                    {currentUser && (
                        <Typography>
                            メールアドレス: {currentUser.email}
                        </Typography>
                    )}
                    <Typography>
                        {currentUser
                            ? "間違いがない場合は、管理者にお問い合わせください。"
                            : "詳しくは管理者にお問い合わせください。"}
                    </Typography>
                </Column>
            }
            footer={<Button onClick={requestLogout}>ログアウト</Button>}
        />
    )
}
